// base color palette
const colors = {
    primary: '#1D2C4C',
    secondary: '#1C85E8',
    red: '#DB2323',
    green: '#14B823',
    blue: '#0043CE',
    yellow: '#F1C21B',
    purple: '#800080',
}

let palette = {
    base: {
        main: '#05060F',
        140: '#05060F',
        120: '#1E1F27',
        100: '#696A6F',
        80: '#ACACAF',
        60: '#EAEAEB',
        40: '#F0F0F1',
        20: '#F3F3F3',
        0: '#FFFFFF',
    }
}

/*
    blend two colors to create the color that is at the percentage away from the first color
    this is a 5 step process
        1: validate input
        2: convert input to 6 char hex
        3: convert hex to rgb
        4: take the percentage to create a ratio between the two colors
        5: convert blend to hex
    @param: color1      => the first color, hex (ie: #000000)
    @param: color2      => the second color, hex (ie: #ffffff)
    @param: percentage  => the distance from the first color, as a decimal between 0 and 1 (ie: 0.5)
    @returns: string    => the third color, hex, represenatation of the blend between color1 and color2 at the given percentage
*/
const blendColors = (color1, color2, percentage) => {
    // 1: validate input, make sure we have provided a valid hex
    if (color1.length != 4 && color1.length != 7)
        throw new error('colors must be provided as hexes');

    if (color2.length != 4 && color2.length != 7)
        throw new error('colors must be provided as hexes');    

    if (percentage > 1 || percentage < 0)
        throw new error('percentage must be between 0 and 1');

    // 2: check to see if we need to convert 3 char hex to 6 char hex, else slice off hash
    //      the three character hex is just a representation of the 6 hex where each character is repeated
    //      ie: #060 => #006600 (green)
    color1 = sixCharsHex(color1)
    color2 = sixCharsHex(color2)

    // 3: we have valid input, convert colors to rgb
    color1 = hexToRGB(color1);
    color2 = hexToRGB(color2);

    // 4: blend
    var color3 = [ 
        (1 - percentage) * color1[0] + percentage * color2[0], 
        (1 - percentage) * color1[1] + percentage * color2[1], 
        (1 - percentage) * color1[2] + percentage * color2[2]
    ];


    // 5: convert to hex
    color3 = '#' + convertToHex(color3[0]) + convertToHex(color3[1]) + convertToHex(color3[2]);

    // return hex
    return color3;
}

/*
    convert a Number to a two character hex string
    must round, or we will end up with more digits than expected (2)
    note: can also result in single digit, which will need to be padded with a 0 to the left
    @param: num         => the number to conver to hex
    @returns: string    => the hex representation of the provided number
*/

const hexToRGB = (c) => {
    return [parseInt(c[0] + c[1], 16), parseInt(c[2] + c[3], 16), parseInt(c[4] + c[5], 16)];
}

const sixCharsHex = (color) => {
    let c = color;
    if (c.length == 4) {
        c = c[1] + c[1] + c[2] + c[2] + c[3] + c[3];
    }
    else {
        c = c.substring(1);
    }
    return c
}

const convertToHex = (num) => {
    let hex = Math.round(num).toString(16);
    if (hex.length == 1)
        hex = '0' + hex;
    return hex;
}

const lightness = [20, 40, 60, 80, 95]

for (const key in colors) {
    palette[key] = {
        main: colors[key],
        [key]: colors[key]
    }
    let obj = {}    
    lightness.forEach(varient => {
        obj[`${100 - varient}`] = blendColors(colors[key], '#FFFFFF', varient / 100)
    })
    palette[key] = {...palette[key], ...obj}
}

export default palette;